import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Ways } from "@/components/site/Ways";
import { WhyItMatters } from "@/components/site/WhyItMatters";
import { Retreats } from "@/components/site/Retreats";
import { Belief } from "@/components/site/Belief";
import { WhoWeServe } from "@/components/site/WhoWeServe";
import { Stories } from "@/components/site/Stories";
import { Prayer } from "@/components/site/Prayer";
import { Booking } from "@/components/site/Booking";
import { Donate } from "@/components/site/Donate";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="site bg-sage text-pine">
      <Header />
      <main id="top">
        <Hero />
        <WhyItMatters />
        <Ways />
        <Retreats />
        <Belief />
        <WhoWeServe />
        <Stories />
        <Prayer />
        <Booking />
        <Donate />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
